import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { store, persistor } from './redux/store';
import MainLayout from './layouts/MainLayout';
import Login from './components/auth/Login';
import PrivateRoute from './components/PrivateRoute';
import ErrorLogs from './components/common/ErrorLogs';
import CardsList from './components/cards/CardsList';
import Users from './components/users/Users';
import UserDetail from './components/users/UserDetail';
import TaskList from './components/tasks/TaskList';
import TaskDetail from './components/tasks/TaskDetail';
function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route element={<PrivateRoute />}>
              <Route path="/cards" element={<MainLayout><CardsList /></MainLayout>} />
              <Route path="/users" element={<MainLayout><Users /></MainLayout>} />
              <Route path="/users/detail" element={<MainLayout><UserDetail /></MainLayout>} />
              <Route path="/tasks" element={<MainLayout><TaskList /></MainLayout>} />
              <Route path="/tasks/:taskId" element={<MainLayout><TaskDetail /></MainLayout>} />
              <Route path="/logs" element={<MainLayout><ErrorLogs /></MainLayout>} />
            </Route>

            {/* Catch all route */}
            <Route path="*" element={<Navigate to="/cards" replace />} />
          </Routes>
        </Router>
      </PersistGate>
    </Provider>
  );
}

export default App;
